import { atlas } from 'graphql/tags'

export const GET_UNREAD_MESSAGES_COUNT = atlas`
  query UnreadMessagesCount {
    unreadMessageCount {
      count
    }
  }
`
